module.exports = __webpack_public_path__ + "static/media/heart.d65ca389.svg";